import getDashboardUrl from 'constants/dashboard';

import React from 'react';

import LanguageSwitcher from 'components/LanguageSwitcher';
import LocalizedLink from 'components/LocalizedLink';
import Logo from 'components/Logo';
import { useI18n } from 'i18n/I18nContext';

export type SiteHeaderVariant = 'onHero' | 'onGreen';

export interface SiteHeaderProps {
  variant?: SiteHeaderVariant;
  /** Show Home link (legal / inner pages) */
  showHome?: boolean;
}

const SiteHeader = ({ variant = 'onHero', showHome = false }: SiteHeaderProps) => {
  const { t } = useI18n();
  const dashboardUrl = getDashboardUrl();
  const shellClass =
    variant === 'onGreen' ? 'gb-site-header gb-site-header--green' : 'gb-site-header';

  return (
    <header className={shellClass}>
      <div className="gb-site-header__inner container">
        <div className="gb-site-header__brand">
          <Logo />
        </div>

        <div className="gb-site-header__actions">
          <LanguageSwitcher variant="onDark" />
          <nav className="gb-site-header__nav" aria-label={t('nav.primary')}>
            {showHome ? (
              <LocalizedLink to="/" className="gb-site-header__link">
                {t('nav.home')}
              </LocalizedLink>
            ) : null}
            <a
              href={dashboardUrl}
              className="gb-site-header__link"
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('nav.login')}
            </a>
            <LocalizedLink to="/onboard" className="gb-site-header__cta">
              {t('nav.signup')}
            </LocalizedLink>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;



// WEBPACK FOOTER //
// ./src/components/SiteHeader.tsx